export { default as Square3Stack3DOutlineIcon } from './Square3Stack3DOutlineIcon';
